[
  {
    "id": "RT01",
    "sourceSection": 5,
    "wordingSnapshot": "v0.27",
    "budget": "core",
    "section": "risk_context",
    "position": 1,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "When weighing up a financial opportunity, which matters more to you?",
    "hint": "Choose the answer closest to you, even if you are not certain. There is no better or more successful type of answer.",
    "options": [
      {
        "id": "A",
        "label": "Reducing the possibility of losing money, even if the potential gain is smaller."
      },
      {
        "id": "B",
        "label": "Neither takes priority: I weigh the possible gain and possible loss together."
      },
      {
        "id": "C",
        "label": "Pursuing a larger potential gain, even when that comes with a greater possibility of loss."
      },
      {
        "id": "D",
        "label": "I am not sure yet.",
        "retired": true
      }
    ]
  },
  {
    "id": "RT02",
    "sourceSection": 5,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "risk_context",
    "position": 2,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "Which statement best describes your current boundary on losing money in a property activity?",
    "hint": "Permanent loss means some of the money you put in is not recovered. This asks what you would be willing to accept, not what you can afford.",
    "options": [
      {
        "id": "A",
        "label": "I would not proceed if I could permanently lose any of the money I put in."
      },
      {
        "id": "B",
        "label": "I could accept the possibility of losing part of my contribution, but not all of it."
      },
      {
        "id": "C",
        "label": "I could accept the possibility of losing all of my contribution if I judged the opportunity worthwhile."
      },
      {
        "id": "D",
        "label": "I would need to understand a specific opportunity before deciding."
      },
      {
        "id": "E",
        "label": "I am not planning to put in my own money."
      },
      {
        "id": "F",
        "label": "I do not know yet."
      }
    ]
  },
  {
    "id": "RT03",
    "sourceSection": 5,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "risk_context",
    "position": 3,
    "component": "scenario_choice",
    "decisionAccess": "interpreted",
    "prompt": "Which of these 2 hypothetical options would you prefer?",
    "hint": "Imagine £10,000 set aside for a 12-month opportunity, separate from household bills and emergency money. Both options involve the same work, with no extra costs or obligations. Each has 2 equally likely outcomes. These invented figures are not property forecasts.",
    "options": [
      {
        "id": "A",
        "label": "Option A."
      },
      {
        "id": "B",
        "label": "Option B."
      },
      {
        "id": "C",
        "label": "I would choose neither option."
      },
      {
        "id": "D",
        "label": "I cannot judge from this example."
      }
    ],
    "scenario": {
      "startingAmountGBP": 10000,
      "periodMonths": 12,
      "independentOfHouseholdMoney": true,
      "equalLikelihood": true,
      "options": [
        {
          "id": "A",
          "amountReturnedGBP": [
            10500,
            9800
          ],
          "gainOrLossGBP": [
            500,
            -200
          ]
        },
        {
          "id": "B",
          "amountReturnedGBP": [
            12000,
            9000
          ],
          "gainOrLossGBP": [
            2000,
            -1000
          ]
        }
      ],
      "forecast": false
    }
  },
  {
    "id": "RT04",
    "sourceSection": 5,
    "wordingSnapshot": "v0.27",
    "budget": "core",
    "section": "risk_context",
    "position": 4,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "How would this uncertainty be likely to affect your day-to-day life?",
    "hint": "Imagine a project expected to finish after 12 months is now expected to take 15 months. Your household bills and the extra project costs are covered. You still do not know whether the project will make a profit or a loss. If you have not been in this position, think about how you usually react when something important takes longer than planned, such as a house sale or building work at home. Choose the closest answer.",
    "options": [
      {
        "id": "A",
        "label": "It would have little effect on my day-to-day life."
      },
      {
        "id": "B",
        "label": "I would worry about it, but mostly carry on as usual."
      },
      {
        "id": "C",
        "label": "It would regularly interfere with my day-to-day activities."
      },
      {
        "id": "D",
        "label": "I cannot judge how I would feel.",
        "retired": true
      }
    ]
  },
  {
    "id": "RT05",
    "sourceSection": 5,
    "wordingSnapshot": "v0.27",
    "budget": "core",
    "section": "risk_context",
    "position": 5,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "If your essential costs were covered separately, what is the longest planned period you would be comfortable having your money tied up?",
    "hint": "Tied up means you cannot get that money back for other uses during that period. This asks about your preference; the actual need for access is considered separately. Choose the closest answer, even if you are not certain.",
    "options": [
      {
        "id": "A",
        "label": "Up to 3 months."
      },
      {
        "id": "B",
        "label": "More than 3 months and up to 12 months."
      },
      {
        "id": "C",
        "label": "More than 1 year and up to 3 years."
      },
      {
        "id": "D",
        "label": "More than 3 years."
      },
      {
        "id": "E",
        "label": "I have no fixed preference about the length of time."
      },
      {
        "id": "F",
        "label": "I am not planning to put in my own money."
      },
      {
        "id": "G",
        "label": "I am not sure yet.",
        "retired": true
      }
    ]
  },
  {
    "id": "RT06",
    "sourceSection": 5,
    "wordingSnapshot": "v0.27",
    "budget": "core",
    "section": "risk_context",
    "position": 6,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "If each option paid you the same total over a year, which payment pattern would you prefer?",
    "hint": "Assume your essential household bills are covered elsewhere. This is only a comparison of when money arrives; it does not describe guaranteed property income. Choose the closest answer, even if you are not certain.",
    "options": [
      {
        "id": "A",
        "label": "Roughly the same amount each month."
      },
      {
        "id": "B",
        "label": "Different amounts through the year, including some months with nothing."
      },
      {
        "id": "C",
        "label": "One payment at the end of the year."
      },
      {
        "id": "D",
        "label": "I have no preference between those patterns."
      },
      {
        "id": "E",
        "label": "I am not sure yet.",
        "retired": true
      }
    ]
  },
  {
    "id": "C06",
    "sourceSection": 5,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "risk_context",
    "position": 7,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "How soon after starting would you need money from this activity to pay essential household bills?",
    "hint": "Think about money available to you after the activity's costs, not its turnover. This asks when the money would be needed, rather than when you would like to receive it.",
    "options": [
      {
        "id": "A",
        "label": "Within the first 3 months."
      },
      {
        "id": "B",
        "label": "After 3 months but within 6 months."
      },
      {
        "id": "C",
        "label": "After 6 months but within 12 months."
      },
      {
        "id": "D",
        "label": "I would not depend on it during the first year."
      },
      {
        "id": "E",
        "label": "I am not sure."
      },
      {
        "id": "F",
        "label": "I would prefer not to say."
      }
    ]
  },
  {
    "id": "C08",
    "sourceSection": 5,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "risk_context",
    "position": 8,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "Thinking only about the money you would personally choose to commit to your first property activity, what would happen if you did not get it back?",
    "hint": "This is a consequence check, not a prediction. Use your chosen contribution, not the full project price or all your savings. If you have not chosen an amount, select the answer that says so.",
    "options": [
      {
        "id": "A",
        "label": "It would set back my property plans, but essential bills and other important financial plans would remain covered."
      },
      {
        "id": "B",
        "label": "It would affect other important financial plans, but essential bills and existing repayments would remain covered."
      },
      {
        "id": "C",
        "label": "It would put essential household bills or existing repayments at risk."
      },
      {
        "id": "D",
        "label": "It depends on the amount; I have not chosen a contribution yet."
      },
      {
        "id": "E",
        "label": "I am not planning to commit my own money."
      },
      {
        "id": "F",
        "label": "I am not sure what the consequences would be."
      },
      {
        "id": "G",
        "label": "I would prefer not to say."
      }
    ]
  },
  {
    "id": "C01",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 1,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "Where do you expect your next property activity to be?",
    "hint": "Choose where the property or activity would be, rather than where you live",
    "options": [
      {
        "id": "A",
        "label": "England."
      },
      {
        "id": "B",
        "label": "Wales."
      },
      {
        "id": "C",
        "label": "Scotland."
      },
      {
        "id": "D",
        "label": "Northern Ireland."
      },
      {
        "id": "E",
        "label": "Outside the UK."
      },
      {
        "id": "F",
        "label": "I have not decided."
      }
    ]
  },
  {
    "id": "C02",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 2,
    "component": "single_choice",
    "decisionAccess": "presentation_only",
    "prompt": "Before we explore your goals, is there a property strategy you are already drawn to?",
    "hint": "This records your starting preference so we can compare it with your result",
    "options": [
      {
        "id": "A",
        "label": "Buy, Refurbish, Rent, Refinance (BRRR)."
      },
      {
        "id": "B",
        "label": "Serviced accommodation."
      },
      {
        "id": "C",
        "label": "No money down property investing."
      },
      {
        "id": "D",
        "label": "Commercial conversions."
      },
      {
        "id": "E",
        "label": "Development."
      },
      {
        "id": "F",
        "label": "HMO."
      },
      {
        "id": "G",
        "label": "Deal sourcing."
      },
      {
        "id": "H",
        "label": "I have no preference yet."
      },
      {
        "id": "I",
        "label": "Something else."
      },
      {
        "id": "J",
        "label": "Buy-to-let: single let."
      },
      {
        "id": "K",
        "label": "Flips: buy, refurbish and sell."
      }
    ]
  },
  {
    "id": "C21",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 3,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "What is the main change you want property to make possible in your life?",
    "hint": "Choose the most important change if several apply",
    "options": [
      {
        "id": "A",
        "label": "Greater financial security."
      },
      {
        "id": "B",
        "label": "Reducing or leaving my current paid work."
      },
      {
        "id": "C",
        "label": "More choice over when or where I work."
      },
      {
        "id": "D",
        "label": "Building a business I enjoy running."
      },
      {
        "id": "E",
        "label": "Building long-term wealth for myself or my family."
      },
      {
        "id": "F",
        "label": "Another reason."
      },
      {
        "id": "G",
        "label": "I am not sure yet."
      }
    ]
  },
  {
    "id": "C03",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 4,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "What is the main financial result you want your property activity to create?",
    "hint": "Choose the one that matters most. If you think of your goal as a monthly figure, choose ongoing income, even if you'll own property to get there.",
    "options": [
      {
        "id": "A",
        "label": "Ongoing income I can use for myself."
      },
      {
        "id": "B",
        "label": "Lump-sum profits from property projects."
      },
      {
        "id": "C",
        "label": "Fees for finding property opportunities for other investors."
      },
      {
        "id": "D",
        "label": "Building wealth in property I keep, more than income I take from it."
      },
      {
        "id": "E",
        "label": "I am not sure yet."
      }
    ]
  },
  {
    "id": "C04",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 5,
    "component": "goal_target",
    "decisionAccess": "interpreted",
    "prompt": "variant_from_C03",
    "hint": null,
    "variants": [
      {
        "when": {
          "question": "C03",
          "equals": "A"
        },
        "id": "income",
        "prompt": "How much money would you ideally like this activity to provide for you each month?",
        "basis": "personal_monthly_income"
      },
      {
        "when": {
          "question": "C03",
          "equals": "B"
        },
        "id": "projects",
        "prompt": "Across a year, how much money would you ideally like completed property projects to provide for you?",
        "basis": "personal_annual_project_proceeds"
      },
      {
        "when": {
          "question": "C03",
          "equals": "C"
        },
        "id": "sourcing",
        "prompt": "Across a year, how much money would you ideally like your sourcing activity to provide for you?",
        "basis": "personal_annual_sourcing_income"
      },
      {
        "when": {
          "question": "C03",
          "equals": "D"
        },
        "id": "equity",
        "prompt": "How much would you like your property to be worth in total, after the mortgages on it?",
        "basis": "personal_net_property_equity"
      },
      {
        "when": {
          "question": "C03",
          "equals": "E"
        },
        "id": "undefined_goal",
        "prompt": "Have you already set a financial target for property?",
        "options": [
          {
            "id": "Y",
            "label": "Yes, but I have not chosen my main financial goal here."
          },
          {
            "id": "N",
            "label": "Not yet."
          },
          {
            "id": "P",
            "label": "I would prefer not to say."
          }
        ]
      }
    ],
    "amountResponse": {
      "oneOf": [
        "AMOUNT",
        "UNSET",
        "DECLINED"
      ],
      "currency": "GBP",
      "amountStorage": "decimal_string",
      "minimum": 0,
      "basisRequired": true,
      "labels": {
        "AMOUNT": "Enter one approximate £ amount for the displayed target.",
        "UNSET": "I have not set a figure yet.",
        "DECLINED": "I would prefer not to say."
      }
    },
    "basisHelp": {
      "income": "£ per month available personally after business costs and tax.",
      "projects": "£ personal money across a year after project costs and tax, not profit per project.",
      "sourcing": "£ personal money across a year after business costs and tax, not gross fees or fee per deal.",
      "equity": "Your share of what the property is worth, less what you owe on it. If you meant a monthly income, press Back and choose ongoing income."
    },
    "invalidateOnVariantChange": true,
    "commonHint": "Think of your total target for this activity or portfolio, not an increase from today. This is a target, not a forecast."
  },
  {
    "id": "C05",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 6,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "From today, when would you ideally like to reach that target?",
    "hint": "This is your preferred timing; your essential household-income deadline was covered in the first section",
    "options": [
      {
        "id": "A",
        "label": "Within 12 months."
      },
      {
        "id": "B",
        "label": "More than 1 year and up to 3 years."
      },
      {
        "id": "C",
        "label": "More than 3 years and up to 5 years."
      },
      {
        "id": "D",
        "label": "More than 5 years."
      },
      {
        "id": "E",
        "label": "I have no fixed date."
      },
      {
        "id": "F",
        "label": "I am not sure yet."
      }
    ],
    "promptVariants": {
      "amount": "From today, when would you ideally like to reach that target?",
      "noAmount": "From today, when would you ideally like property to start delivering your main financial goal?"
    },
    "recordBasis": {
      "amount": "attainment",
      "noAmount": "onset"
    },
    "reviewAfter": [
      "C03",
      "C04"
    ]
  },
  {
    "id": "C07",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 7,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "How much cash could you set aside for getting started today?",
    "hint": "Exclude household bills, your emergency reserve, and money you still hope to borrow or raise",
    "options": [
      {
        "id": "A",
        "label": "£0."
      },
      {
        "id": "B",
        "label": "More than £0 but under £10,000."
      },
      {
        "id": "C",
        "label": "£10,000 to under £25,000."
      },
      {
        "id": "D",
        "label": "£25,000 to under £50,000."
      },
      {
        "id": "E",
        "label": "£50,000 to under £100,000."
      },
      {
        "id": "F",
        "label": "£100,000 or more."
      },
      {
        "id": "G",
        "label": "I am not sure."
      },
      {
        "id": "H",
        "label": "I would prefer not to say."
      }
    ]
  },
  {
    "id": "C09",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 8,
    "component": "multiple_choice",
    "decisionAccess": "interpreted",
    "prompt": "Apart from that cash, where do you expect money for the activity to come from?",
    "hint": "Select all that apply; plans and agreed funding will be treated separately",
    "options": [
      {
        "id": "A",
        "label": "Borrowing from a lender."
      },
      {
        "id": "B",
        "label": "Money from another person or business."
      },
      {
        "id": "C",
        "label": "Paying a seller some or all of the price later."
      },
      {
        "id": "D",
        "label": "Releasing money from a property I already own."
      },
      {
        "id": "E",
        "label": "No external money planned."
      },
      {
        "id": "F",
        "label": "I have not decided."
      },
      {
        "id": "G",
        "label": "I would prefer not to say."
      }
    ],
    "selection": {
      "minimum": 1,
      "inclusive": [
        "A",
        "B",
        "C",
        "D"
      ],
      "exclusive": [
        "E",
        "F",
        "G"
      ],
      "unselectedMeaning": "no_positive_evidence"
    }
  },
  {
    "id": "C10",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 9,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "How many hours a week could you reliably give this over the next 6 months?",
    "hint": "Include learning, finding opportunities and overseeing work, alongside your existing commitments",
    "options": [
      {
        "id": "A",
        "label": "None."
      },
      {
        "id": "B",
        "label": "More than 0 but under 5 hours."
      },
      {
        "id": "C",
        "label": "5 to under 10 hours."
      },
      {
        "id": "D",
        "label": "10 to under 20 hours."
      },
      {
        "id": "E",
        "label": "20 hours or more."
      },
      {
        "id": "F",
        "label": "My availability varies too much to give a reliable amount."
      }
    ]
  },
  {
    "id": "C13",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 10,
    "component": "multiple_choice",
    "decisionAccess": "interpreted",
    "prompt": "Which of these tasks have you personally carried out in practice?",
    "hint": "Select all that apply, in property or another field; courses or observation alone do not count here",
    "options": [
      {
        "id": "A",
        "label": "Finding and winning paying clients."
      },
      {
        "id": "B",
        "label": "Analysing property, business or investment figures."
      },
      {
        "id": "C",
        "label": "Carrying out building or refurbishment work."
      },
      {
        "id": "D",
        "label": "Managing a project's budget and schedule."
      },
      {
        "id": "E",
        "label": "Managing lettings or tenant relationships."
      },
      {
        "id": "F",
        "label": "Running guest accommodation or hospitality services."
      },
      {
        "id": "G",
        "label": "Negotiating business or funding agreements."
      },
      {
        "id": "H",
        "label": "Working on planning applications or development permissions."
      },
      {
        "id": "I",
        "label": "None of these yet."
      },
      {
        "id": "J",
        "label": "I am not sure which apply."
      }
    ],
    "selection": {
      "minimum": 1,
      "inclusive": [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H"
      ],
      "exclusive": [
        "I",
        "J"
      ],
      "unselectedMeaning": "no_positive_evidence"
    }
  },
  {
    "id": "C14",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 11,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "What role would you prefer while getting started?",
    "hint": "Choose the role you would want; we will assess whether the support for it exists",
    "options": [
      {
        "id": "A",
        "label": "Carry out most of the day-to-day work myself."
      },
      {
        "id": "B",
        "label": "Organise people and make day-to-day decisions."
      },
      {
        "id": "C",
        "label": "Review progress and make major decisions while someone else manages day to day."
      },
      {
        "id": "D",
        "label": "Only provide money, with no delivery or oversight role."
      },
      {
        "id": "E",
        "label": "I am not sure yet."
      }
    ]
  },
  {
    "id": "C15",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 12,
    "component": "multiple_choice",
    "decisionAccess": "interpreted",
    "prompt": "Which of these are firm limits for you, even if they reduce your options?",
    "hint": "Select all that apply; choose limits you would not cross, rather than preferences",
    "options": [
      {
        "id": "A",
        "label": "Keep evenings and weekends free from routine property work."
      },
      {
        "id": "B",
        "label": "Keep normal weekday working hours free from routine property work."
      },
      {
        "id": "C",
        "label": "Do not borrow in my own name."
      },
      {
        "id": "D",
        "label": "Do not personally guarantee borrowing by another person or company."
      },
      {
        "id": "E",
        "label": "Own a share of the property from my first activity."
      },
      {
        "id": "F",
        "label": "Keep the final say over major decisions."
      },
      {
        "id": "G",
        "label": "Do not personally handle day-to-day tenant or guest issues."
      },
      {
        "id": "H",
        "label": "Another firm limit not listed here."
      },
      {
        "id": "I",
        "label": "None of these is a firm limit."
      },
      {
        "id": "J",
        "label": "I am not sure yet."
      }
    ],
    "selection": {
      "minimum": 1,
      "inclusive": [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H"
      ],
      "exclusive": [
        "I",
        "J"
      ],
      "unselectedMeaning": "no_positive_evidence"
    }
  },
  {
    "id": "C16",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 13,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "Which type of work would you most willingly take responsibility for regularly?",
    "hint": "Choose the role you would most enjoy. Negotiating deals, raising money and analysing opportunities can support many strategies; they do not choose a strategy for you.",
    "options": [
      {
        "id": "A",
        "label": "Finding and winning clients."
      },
      {
        "id": "B",
        "label": "Negotiating property or funding agreements."
      },
      {
        "id": "C",
        "label": "Researching and analysing property opportunities."
      },
      {
        "id": "D",
        "label": "Coordinating building or planning projects."
      },
      {
        "id": "E",
        "label": "Running guest accommodation: bookings, marketing and service providers."
      },
      {
        "id": "F",
        "label": "Managing lettings and tenant relationships."
      },
      {
        "id": "G",
        "label": "Overseeing teams and business performance."
      },
      {
        "id": "H",
        "label": "None of these appeals to me."
      },
      {
        "id": "I",
        "label": "I am not sure yet."
      }
    ]
  },
  {
    "id": "C20",
    "sourceSection": 6,
    "wordingSnapshot": "v0.18",
    "budget": "core",
    "section": "property",
    "position": 14,
    "component": "single_choice",
    "decisionAccess": "interpreted",
    "prompt": "Would you accept a first stage that builds skills or resources before it delivers your main property goal?",
    "hint": "This could involve a different activity at first; it is not a promise of income or a requirement to buy training",
    "options": [
      {
        "id": "A",
        "label": "Yes, if the work fits me."
      },
      {
        "id": "B",
        "label": "Only within a limit I would want to define."
      },
      {
        "id": "C",
        "label": "No, my first activity must directly serve my main goal."
      },
      {
        "id": "D",
        "label": "I am not sure yet."
      }
    ]
  }
]
